import { Redirect } from 'react-router-dom'
import { customRedirectionToProvidencePath } from '../../routing/route.constants'

const RedirectToProvidenceFlows = () => {
  return <Redirect to={customRedirectionToProvidencePath} />
}

export default RedirectToProvidenceFlows
